// extracted by mini-css-extract-plugin
module.exports = {"sound":"BackgroundMusic_sound__1LvAj","dark":"BackgroundMusic_dark__1k2dI"};